import React from 'react';
import './index.scss';

interface IPreviewTitleProps {
  title: string;
}

const PreviewTitle = (props: IPreviewTitleProps) => {
  const { title } = props;

  return (
    <div className='dhb-studio-opinions-preiview-title-contanier'>
      <div className='dhb-studio-opinions-preiview-title-sides'>
        <div className='dhb-studio-opinions-preiview-title-line'></div>
        <div className='dhb-studio-opinions-preiview-title-box'></div>
      </div>
      <div className='dhb-studio-opinions-preiview-title'>
        {title}
      </div>
      <div className='dhb-studio-opinions-preiview-title-sides'>
        <div className='dhb-studio-opinions-preiview-title-box'></div>
        <div className='dhb-studio-opinions-preiview-title-line'></div>
      </div>
    </div>
  );
};

export default PreviewTitle;
